export const FacilityDetail = (json: IFacilityDetail): IFacilityDetailModel => ({
	id: json.id,
	name: json.name,
	type: json.type,
	typeLabel: getFacilityTypeLabel(json.type),
	capabilities: json.capabilities ?? [],
	capabilityLabels: (json.capabilities ?? []).map(getFacilityCapabilityLabel),
	warehousePickupPointId: json.orders_pickup_point_id ?? null,
})

export const FacilityDetailUpdatePayload = (
	name: string,
	type: string,
	capabilities: string[],
	warehousePickupPointId: number | null,
): IFacilityDetailUpdate => ({
	name,
	type,
	capabilities,
	orders_pickup_point_id: warehousePickupPointId,
})

export const parseFacilityWarehousePickupPointId = (value: string): number | null => {
	const trimmed = value.trim()
	if (!trimmed) return null

	const parsed = Number(trimmed)
	return Number.isNaN(parsed) ? null : parsed
}
